import React, { Component } from 'react';
import Header from './header/header'
import ContactForm from "./form/ContactForm";



class Contact extends Component {
    constructor(props) {
        super(props);
        localStorage.setItem('catData',"");
    }
    render() {
        return(

        <div>
            <Header />
            <ContactForm/>
        </div>
    );
}
}

export default Contact;


// WEBPACK FOOTER //
// ./src/contact/Contact.js